import { create } from "zustand";

interface CreateCanvasModalState {
  isOpen: string | null;
  setIsOpen: (state: string | null) => void;
}

export const useCreateCanvasModal = create<CreateCanvasModalState>((set) => ({
  isOpen: null,
  setIsOpen: (state) => set({ isOpen: state }),
}));
